import { render, staticRenderFns } from "./InitForm.vue?vue&type=template&id=36782e4e&scoped=true"
import script from "./InitForm.vue?vue&type=script&lang=js"
export * from "./InitForm.vue?vue&type=script&lang=js"
import style0 from "./InitForm.vue?vue&type=style&index=0&id=36782e4e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36782e4e",
  null
  
)

export default component.exports